enum LevelsEnum {
  Home = 1, // Never used because Home is a dynamic page
  Login = 2,
  Registration = 3,
  Contents = 4,
  Bell = 5,
  MyAccount = 6,
  Brand = 7,
  Error = 8,
  Dynamic = 9,
}

export default LevelsEnum;
